import "./index.scss";

import { Backdrop, Box, Fade, Modal, Stack, Tab, Tabs } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/images/square-buttons/close-small.svg";
import Button from "components/Button";
import { ReactNode, SyntheticEvent, useState } from "react";

import { IChangelogData } from "../Version";

interface IChangeLog {
  open: boolean;
  data: IChangelogData[];
  onClose?: () => void;
}
interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
  className: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 3, py: 1 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number | string) {
  return {
    "aria-controls": `vertical-tabpanel-${index}`,
    id: `vertical-tab-${index}`,
  };
}

const Changelog = ({ open, data, onClose }: IChangeLog) => {
  // const { open, onClose, onConfirm, title, label } = props;
  const [value, setValue] = useState(0);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <Modal
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      open={open}
      onClose={handleCloseModal}
    >
      <Fade in={open}>
        <Stack className="changelog-modal">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            marginBottom="40px"
            className="header"
          >
            <h1>Your Management Station has gotten better!</h1>
            <DeleteIcon width="24px" height="24px" onClick={handleCloseModal} />
          </Stack>
          <Stack>
            <Box
              sx={{ bgcolor: "background.paper", display: "flex", flexGrow: 1, height: "370px" }}
            >
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Changelog versions"
              >
                {data.map((changelog, index) => (
                  <Tab label={changelog.version} {...a11yProps(index)} className="tab-button" />
                ))}
              </Tabs>
              {data.map((changelog, index) => (
                <TabPanel value={value} index={index} className="tab-content-wrapper">
                  <>
                    <Box sx={{ mb: 1 }}>
                      <h2>{changelog.date}</h2>
                    </Box>
                    <Box>
                      <div
                        className="tab-content"
                        dangerouslySetInnerHTML={{ __html: changelog.content }}
                      ></div>
                    </Box>
                  </>
                </TabPanel>
              ))}
            </Box>
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="flex-end" marginTop="30px">
            <Stack direction="row" alignItems="center" spacing={3}>
              <Button label="Close" className="confirm-button" onClick={handleCloseModal} />
            </Stack>
          </Stack>
        </Stack>
      </Fade>
    </Modal>
  );
};

export default Changelog;
